import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Input, Button, Layout, message } from 'antd';
import axios from 'axios';
import logo from '../images/logo.png';
import { apiUrl } from './config';
import '../styles/ChangePassword.css';

const { Content } = Layout;

const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPasswordHint, setShowPasswordHint] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { email } = location.state || {};

    const passwordPattern = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;

    const handleChangePassword = async () => {
        if (!email) {
            message.error('Email non trovata.');
            return;
        }

        if (!passwordPattern.test(newPassword)) {
            message.error('La password deve contenere almeno 8 caratteri e includere almeno un numero.');
            return;
        }

        if (newPassword !== confirmPassword) {
            message.error('Le password non corrispondono');
            return;
        }

        try {
            const response = await axios.put(`${apiUrl}/api/auth/change-password`, {
                email: email.toLowerCase(),
                newPassword,
            });

            if (response.data.message === 'Password aggiornata con successo.') {
                message.success('Password aggiornata con successo. Reindirizzamento al login...');
                setTimeout(() => {
                    navigate('/login'); // Reindirizza alla pagina di login
                }, 2000); // Aspetta 2 secondi prima del reindirizzamento
            }
        } catch (error) {
            console.error('Errore durante il cambio password:', error);
            message.error('Errore durante il cambio password.');
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setNewPassword(value);

        // Mostra il messaggio finché il pattern non è rispettato
        setShowPasswordHint(!passwordPattern.test(value));
    };

    return (
        <Layout style={{ minHeight: '100vh', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--sfondo)' }}>
            <Content
                style={{
                    width: '100%',
                    maxWidth: '400px',
                    padding: '20px',
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                }}
            >
                <img src={logo} alt="FitLab Logo" className="logo" style={{ width: '200px', marginBottom: '20px' }} />
                <div className="change-title">CAMBIA LA TUA PASSWORD</div>
                <Form layout="vertical" onFinish={handleChangePassword}>
                    <Form.Item
                        label="Nuova Password"
                        required
                        className="no-scroll-item"
                        rules={[
                            { required: true, message: 'Inserisci la nuova password' },
                            {
                                pattern: passwordPattern,
                                message: 'La password deve contenere almeno 8 caratteri e un numero',
                            },
                        ]}
                    >
                        <Input.Password
                            placeholder="Nuova password"
                            value={newPassword}
                            onChange={handlePasswordChange}
                        />
                        {showPasswordHint && (
                            <div className="password-hint">
                                La password deve contenere almeno 8 caratteri e includere almeno un numero.
                            </div>
                        )}
                    </Form.Item>
                    <Form.Item
                        label="Conferma Nuova Password"
                        required
                        className="no-scroll-item"
                        rules={[
                            { required: true, message: 'Conferma la nuova password' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Le password non corrispondono'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            placeholder="Conferma nuova password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            style={{ backgroundColor: 'var(--primario)', borderColor: 'var(--primario)' }}
                        >
                            Cambia Password
                        </Button>
                    </Form.Item>
                </Form>
            </Content>
        </Layout>
    );
};

export default ChangePassword;
